import { Box, IconButton, Stack, Typography } from "@mui/joy";
import ButtonWithModal from "components/common/ButtonWithModal";
import TypographyWithLinkSubstring from "components/common/TypographyWithLinkSubstring";
import { useTranslation } from "react-i18next";
import LinkV2 from "../common/LinkV2";
import { theme } from "../../styles/theme";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../recoil/userAtom";
import useIsTabExists from "../../hooks/useIsTabExists";
import useOpenTask from "../../hooks/useOpenTask";
import { useNavigate } from "react-router-dom";

export default function CxButton({
  type = "icon",
}: {
  type?: "icon" | "link";
}) {
  const { t: t_ui } = useTranslation("translation", {
    keyPrefix: "ui",
  });

  const user = useRecoilValue(userAtom);

  const isTabExists = useIsTabExists();
  const navigate = useNavigate();

  return isTabExists ? (
    <Box onClick={() => navigate("/support/faq")}>
      <LinkV2 text={"고객센터"} />
    </Box>
  ) : (
    <ButtonWithModal
      buttonText={""}
      size="lg"
      title={"고객센터"}
      textAlign="center"
      render={
        type === "link" ? (
          <LinkV2 text={"고객센터"} />
        ) : (
          <IconButton size="sm" variant="plain" color="neutral">
            <span className="material-symbols-outlined">help</span>
          </IconButton>
        )
      }
      content={
        <Stack
          alignItems={"center"}
          spacing={3}
          sx={{ width: "100%", color: "text.tertiary" }}
        >
          <Stack alignItems={"center"} spacing={1}>
            <Typography
              variant={"Body"}
              sx={{ fontWeight: 500, color: theme.vars.palette.Content.Strong }}
            >
              <a href="mailto:support@orwellhealth.org?subject=문의드립니다&body=닉네임:%0D%0A문의사항:">
                support@orwellhealth.org
              </a>
            </Typography>
            <Typography
              variant={"Footnote"}
              sx={{ fontWeight: 400, color: theme.vars.palette.Content.Medium }}
            >
              영업일 기준 1일 내로 답변 드려요.
            </Typography>
          </Stack>
          <Typography>
            <TypographyWithLinkSubstring
              mainString={"환불 및 페이백 문의"}
              linkSubstrings={[
                {
                  linkString: "환불 및 페이백 문의",
                  url:
                    user?.pricingModel === "c"
                      ? "https://orwellhealth.notion.site/Distancing-2335cdab4df580539856fa3bf8c16e07?pvs=73"
                      : user?.pricingModel === undefined
                      ? "https://orwellhealth.notion.site/d07b7b28b8e04d858a93641249748b0f"
                        : "https://orwellhealth.notion.site/Payback-2335cdab4df5800a9e2cccc1167b8ca4",
                },
              ]}
              linkOpenType="link"
            />
          </Typography>
        </Stack>
      }
    />
  );
}
